export const textEng=[
    "PARLIAMENT FOR THE FUTURE",
    "- CLIMATE ACTION NOW!",
    "Send an email to a Member of the Swedish Parliament ",
    "Find out more",
    "How do I get involved? ",
]